import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import CheckInput, { InputType } from '../../../../../atoms/CheckInput';
import BooksPaymentCard from './components/BooksPaymentCard';
import { CardSelection } from '../../../../../interfaces/merchants/resources/books';
import { UserMeReduxState } from '../../../../../interfaces/users';

import css from './InputPaymentMyCreditCard.module.scss';

interface Props {
  me: UserMeReduxState;
  onSelect: (cardSelection: CardSelection) => void;
  mySelection?: CardSelection;
}

const InputPaymentMyCreditCard: React.FC<Props> = (props) => {
  const { me, mySelection, onSelect } = props;
  const intl = useIntl();

  const handleSelect = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const {
        currentTarget: { value },
      } = e;
      const mySelection = value as CardSelection;
      onSelect(mySelection);
    },
    [onSelect],
  );

  if (!me.creditCard) {
    // クレジットカードの履歴がない場合は表示する必要なし
    return null;
  }

  return (
    <li className={css.InputPaymentMyCreditCard}>
      <BooksPaymentCard
        className={css.InputPaymentMyCreditCard__Item}
        tailDigits={me.creditCard.tailDigits}
        value={CardSelection.Used}
        checked={mySelection === CardSelection.Used}
        // @ts-expect-error strictFunctionTypes
        onChange={handleSelect}
      />
      <CheckInput
        className={css.InputPaymentMyCreditCard__Item}
        type={InputType.Radio}
        value={CardSelection.Another}
        checked={mySelection === CardSelection.Another}
        // @ts-expect-error strictFunctionTypes
        onChange={handleSelect}
        name="payment-creditcard"
      >
        {intl.formatMessage({ id: 'books.forms.addNewCreditCard' })}
      </CheckInput>
    </li>
  );
};

export default InputPaymentMyCreditCard;
